import React, { useEffect, useState } from 'react';
import {
  CloseSideLeafButton,
  CloseIcon,
  ContainerOverlay,
  SideLeafContainer,
  SideLeafHeader
} from './styles';

interface ISideLeafProps {
  from: 'left' | 'right';
  onClose(): void;
  closeSideLeafFromParent?: boolean;
  header?: React.ReactNode;
}

const SideLeaf: React.FC<ISideLeafProps> = ({
  from,
  onClose,
  closeSideLeafFromParent,
  header,
  children
}) => {
  const [closeAnimation, setCloseAnimation] = useState(false);

  const closeSideLeaf = () => {
    setCloseAnimation(true);

    setTimeout(() => {
      onClose();
    }, 250);
  };

  useEffect(() => {
    // usado para aplicar a animação de fechar sideLeaf ao selecionar um item do parent
    if (closeSideLeafFromParent) {
      closeSideLeaf();
    }
  });

  return (
    <ContainerOverlay
      onClick={closeSideLeaf}
      className={closeAnimation ? 'closeAnimation' : ''}
    >
      <SideLeafContainer
        onClick={(e) => e.stopPropagation()}
        className={`${from === 'left' ? 'from-left' : 'from-right'} ${
          closeAnimation ? 'closeAnimation' : ''
        }`}
      >
        <SideLeafHeader>
          {header}

          <CloseSideLeafButton onClick={closeSideLeaf}>
            <CloseIcon />
          </CloseSideLeafButton>
        </SideLeafHeader>

        {children}
      </SideLeafContainer>
    </ContainerOverlay>
  );
};

export default SideLeaf;
